import * as React from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { NewsItem_NewsItemEdgeFragment } from 'generated/graphql'
// TODO   추후 ua 컴포넌트 import 수정필요
import ScreenNewsItemFeed from '@app.feature/channel/channel.newsItem/screen/ScreenNewsItemFeed.ua'
import ScreenNewsItemFeedLoading from '@app.feature/channel/channel.newsItem/screen/ScreenNewsItemFeedLoading'
import EmptyCard from '@app.feature/channel/channel.search/component/EmptyCard'

gql`
  fragment FollowList_ChannelConnection on ChannelConnection {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      ...ChannelCardList_ChannelEdge
    }
  }
`

type Props = {
  data: NewsItem_NewsItemEdgeFragment[]
  loading: boolean
  skeletonSize?: number
}

const NewsList: React.FC<Props> = ({ loading, data, skeletonSize = 3 }) => {
  const skeletonArr = new Array(skeletonSize).fill('')
  return (
    <StyledWrapper>
      <div className="news-item-card-list">
        {loading &&
          skeletonArr.map((_, idx) => <ScreenNewsItemFeedLoading key={idx} />)}
        {data.map((edge) => (
          <ScreenNewsItemFeed
            data={edge}
            key={`news-item-${edge.header?.id}`}
            isExpandContent
            isShowFollowBtn
          />
        ))}
      </div>
      {!loading && data.length === 0 && <EmptyCard />}
    </StyledWrapper>
  )
}

export default NewsList

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  .news-item-card-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .end-content {
    display: flex;
    justify-content: center;
    padding: 20px;
    color: #999999;
  }
`
